import React, { useEffect, useState } from "react";
import "./Loader.css";

/* ─── Loader — "BOOT SHEET" ─────────────────────────────────
   New UI, same timing contract as before:
     · 120 ms per character
     · progress = ((i + 1) / text.length) * 100
     · setDone(true) 800 ms after the last character
     · same strings: Karanks1436 / Full Stack Developer &
       Designer / Loading Experience... / Welcome
   This file no longer imports framer-motion — every moving
   part is CSS, so the loader paints before the JS bundle does.
   ─────────────────────────────────────────────────────────── */

const Loader = () => {
  const text = "Karanks1436";
  const [displayedText, setDisplayedText] = useState("");
  const [done, setDone] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      setDisplayedText(text.slice(0, i + 1));
      setProgress(((i + 1) / text.length) * 100);
      i++;

      if (i === text.length) {
        clearInterval(interval);
        setTimeout(() => setDone(true), 800);
      }
    }, 120);

    return () => clearInterval(interval);
  }, []);

  const pct = Math.round(progress);

  return (
    <div className={`ld-root ${done ? "is-done" : ""}`} role="status" aria-live="polite">
      <span className="ld-sr">{done ? "Ready. Welcome." : "Loading experience."}</span>

      {/* ── backdrop: rules, scanline, frame ── */}
      <div className="ld-rules" aria-hidden="true">
        <span /><span /><span /><span />
      </div>
      <span className="ld-scan" aria-hidden="true" />

      <div className="ld-frame" aria-hidden="true">
        <span className="ld-corner ld-corner--tl" />
        <span className="ld-corner ld-corner--tr" />
        <span className="ld-corner ld-corner--bl" />
        <span className="ld-corner ld-corner--br" />
      </div>

      {/* ── top bar ── */}
      <header className="ld-top">
        <span className="ld-brand">KKS<span>·</span>1436</span>
        <span className="ld-top__meta">
          Boot sequence
          <i aria-hidden="true" />
          <b>{done ? "ready" : "running"}</b>
        </span>
      </header>

      {/* ── stage ── */}
      <main className="ld-stage">
        <span className="ld-ghost" aria-hidden="true">1436</span>

        <div className="ld-stage__main">
          <span className="ld-kicker"><i aria-hidden="true" /> Portfolio — loading</span>

          <h1 className="ld-word">
            <span className="ld-word__txt">{displayedText}</span>
            <span className="ld-caret" aria-hidden="true" />
          </h1>

          <p className="ld-sub">Full Stack Developer &amp; Designer</p>
        </div>

        <div className="ld-side" aria-hidden="true">
          <span className="ld-side__num">{pct}<i>%</i></span>
          <span className="ld-side__cap">Loading</span>
        </div>
      </main>

      {/* ── footer: tick ruler + status ── */}
      <footer className="ld-foot">
        <div className="ld-ruler" aria-hidden="true">
          <span className="ld-ruler__ticks" />
          <span className="ld-ruler__fill" style={{ width: `${progress}%` }}>
            <span className="ld-ruler__head" />
          </span>
        </div>

        <div className="ld-foot__row">
          <span className="ld-status">
            <i aria-hidden="true" />
            {done ? "Ready — welcome" : "Loading Experience..."}
          </span>
          <span className="ld-pct">{pct}<i>%</i></span>
        </div>
      </footer>
    </div>
  );
};

export default Loader;
